import { useQuery } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'

export const GET_EVENT_BY_ID_CACHE_KEY = 'get-event-by-id'

export function useEventById(id: string) {
  const handleRetry = useHandleRetry()
  return useQuery([GET_EVENT_BY_ID_CACHE_KEY, id], () => ApiService.Events.getEventWithReminders(id), {
    enabled: !!id,
    retry: handleRetry,
    staleTime: 0,
    refetchOnWindowFocus: false,
  })
}
